export default __webpack_public_path__ + "fa350e72d144502328e3bc292537f67b.svg";